<greco-locked-gallery [user]="user"> </greco-locked-gallery>
